import React, { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { Constants } from "../../CommonMethhods/Constants";
import { DASHBOARD_DEFAULT } from "../../Configuration/API_URL";
import Leads from "../../asset/images/onboarded.svg";
import Pending from "../../asset/images/pending.svg";
import Created from "../../asset/images/completed.svg";
import Rejected from "../../asset/images/rejected.svg";
import SmallLoader from "../Common/smallLoader";
import { useNavigate } from "react-router-dom";
import {
  AESEncryption,
  ApiResDecrypt,
  truncate,
} from "../../CommonMethhods/CommonMethods";

function NewClientStatus(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [filterBy, setFilterBy] = useState("yearly");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);

  const [clientStatus, setClientStatus] = useState({
    total: null,
    newClients: null,
    onboarded: null,
    pending: null,
    created: null,
    notInterested: null,
    percentage: null,
  });

  const getClientStatus = async () => {
    setLoader(true);
    let payloadValue = {
      duration: filterBy,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getStatus = await axios.post(
        DASHBOARD_DEFAULT.ClientStatus_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      // const res = getStatus.data.data;
      let res = ApiResDecrypt(getStatus?.data);
      // updating state for the data to be p[ased to the component
      setClientStatus({
        total: res.data.totalClients,
        newClients: res.data.newClients,
        onboarded: res.data.onboarded,
        pending: res.data.pending,
        created: res.data.created,
        rejected: res.data.rejected,
        notInterested: res.data.notInterested,
        percentage: res.data.percentage,
      });
      setLoader(false);
    } catch (error) {
      console.log(error);
      // if (error.request.status == 401) {
      //   localStorage.clear("");
      //   navigate("/");
      // }
      setLoader(false);
    }
  };

  useEffect(() => {
    getClientStatus();
  }, [filterBy]);

  const handleOnChange = (e) => {
    if (e.target.value) {
      setFilterBy(e.target.value);
    }
  };
  function handleNavigate(data) {
    navigate("/onboarding");
    localStorage.setItem("activeTab", data);
    // setTimeout(() => {
    //   let tab = document.querySelector("[data-rr-ui-event-key='Leads']");

    //   tab.classList.add("active")
    //   tab.click()
    // }, 3000);
  }

  return (
    <>
      <div className="card-box bottom-25 client-onboarded-data">
        <div className="card-title">
          <h2>{Constants.ClientOnboardingData}</h2>

          <div className="dropdown-filter">
            <div className="card-tabs mt-0">
              <div className="dropdown-filter">
                <Form.Select
                  size="lg"
                  aria-label="Default select example"
                  onChange={handleOnChange}
                >
                  <option value="yearly">{Constants.Yearly}</option>
                  <option value="quarterly">{Constants.Quarterly}</option>
                  <option value="monthly">{Constants.Monthly}</option>
                  <option value="weekly">{Constants.Weekly}</option>
                  <option value="Yesterday">{Constants.Yesterday}</option>
                  <option value="Overall">{Constants.Overall}</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3 ">
            <div
              className="data-card"
              onClick={() => handleNavigate("Leads")}
            >
              <img src={Leads} alt="Leads" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                    {Constants.Kyc_Application_Submitted}
                  </span>
                </div>
                {/* <div> */}
                <p className="data-card-value">
                  {loader ? (
                    <SmallLoader />
                  ) : (
                    <>
                      {clientStatus.onboarded == undefined || null
                        ? "0"
                        : clientStatus.onboarded}
                    </>
                  )}
                </p>
                <p className="data-card-label">{Constants.Submitted}</p>
                {/* </div> */}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card"
              onClick={() => handleNavigate("Pending")}
            >
              <img src={Pending} alt="Pending" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                    Number of Applications not submitted for client code
                    generation.
                  </span>
                </div>
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus.pending == undefined || null
                          ? "0"
                          : clientStatus.pending}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">{Constants.Pending}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card"
              onClick={() => handleNavigate("Created")}
            >
              <img src={Created} alt="Created" />
              <div className="data-tooltip-wrapper">
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus.created == undefined || null
                          ? "0"
                          : clientStatus.created}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">{Constants.Created}</p>
                </div>
              </div>
              <div className="tooltip123">
                {truncate(<span className="icon-info-icon"></span>)}
                <span className="tooltiptext new">
                  Number of Applications submitted and Client code activated.
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="data-card"
              onClick={() => handleNavigate("Rejected")}
            >
              <img src={Rejected} alt="Rejected" />
              <div className="data-tooltip-wrapper">
                <div className="tooltip123">
                  {truncate(<span className="icon-info-icon"></span>)}
                  <span className="tooltiptext new">
                    Number of Applications in Rejected status.
                  </span>
                </div>
                <div>
                  <p className="data-card-value">
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <>
                        {clientStatus.rejected == undefined || null
                          ? "0"
                          : clientStatus.rejected}
                      </>
                    )}
                  </p>
                  <p className="data-card-label">{Constants.Rejected}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewClientStatus;
